import gql from 'graphql-tag';

const RestrictionsFragment = gql`
	fragment RestrictionsFragment on ScheduledRestriction {
		user {
			edges {
				node {
					email
					permissionType
					displayName
					accountId
					publicName
					profilePicture {
						path
					}
				}
			}
		}
		group {
			edges {
				node {
					name
					id
				}
			}
		}
	}
`;

export const PublishModalWithMoreOptionsQuery = gql`
	query PublishModalWithMoreOptionsQuery($contentId: ID) {
		singleContent(id: $contentId) {
			id
			type
			space {
				id
			}
			schedulePublishInfo {
				date
				versionComment
				minorEdit
				targetType
				targetLocation {
					parentId
					destinationSpace {
						id
						key
						alias
					}
				}
				restrictions {
					update {
						...RestrictionsFragment
					}
					read {
						...RestrictionsFragment
					}
				}
			}
		}
	}
	${RestrictionsFragment}
`;
